import { createContext, useContext } from 'react';

// Contexto y hook de los avisos, fuera del archivo del componente. Mismo
// criterio que `contextoAuth.js`: un archivo que exporta un componente Y
// otras cosas rompe la recarga en caliente para todo el archivo.
export const ContextoAvisos = createContext(null);

// Fuera de un proveedor NO revienta: devuelve funciones vacías. Un aviso
// que no se puede pintar es un aviso que se pierde; una pantalla que se
// cae por intentar avisar es mucho peor.
const SILENCIO = {
  avisar: () => {}, exito: () => {}, info: () => {}, aviso: () => {}, error: () => {},
};

export function useAvisos() {
  return useContext(ContextoAvisos) || SILENCIO;
}
